import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './screens/Login';
import SelectDealer from './screens/SelectDealer';
import StartSession from './screens/StartSession';
import Survey from './screens/Survey';
import SessionEnd from './screens/SessionEnd';
import ChangePassword from './screens/ChangePassword';
import DemoStart from './demo/DemoStart';
import DemoBar from './demo/DemoBar';

const API = process.env.REACT_APP_API_URL || 'https://web-production-87efe.up.railway.app';
export { API };

// The web demo build (REACT_APP_DEMO=1): a stand-in server inside the page, sample data
export function isDemo() {
  return process.env.REACT_APP_DEMO === '1';
}

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
      {isDemo() && <DemoBar />}
      <Routes>
        <Route path="/login" element={isDemo() ? <DemoStart /> : <Login />} />
        <Route path="/select-dealer" element={
          <PrivateRoute><SelectDealer /></PrivateRoute>
        } />
        <Route path="/start-session" element={
          <PrivateRoute><StartSession /></PrivateRoute>
        } />
        <Route path="/survey" element={
          <PrivateRoute><Survey /></PrivateRoute>
        } />
        <Route path="/session-end" element={
          <PrivateRoute><SessionEnd /></PrivateRoute>
        } />
        <Route path="/change-password" element={
          <PrivateRoute><ChangePassword /></PrivateRoute>
        } />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;